import {
  NOTIFICATION_THEME_BLUE,
  NOTIFICATION_THEME_PURPLE,
  type NotificationTheme,
} from 'Components/InAppNotification/constants';

export const NOTIFICATION_MATCH_TYPE_SUPERBOOST = 'superboost';
export const NOTIFICATION_MATCH_TYPE_BOOST = 'boost';
export const NOTIFICATION_MATCH_TYPE_SUPER_LIKE = 'super_like';
export const NOTIFICATION_MATCH_TYPE_FAST_MATCH = 'fastmatch';
export const NOTIFICATION_MATCH_TYPE_NORMAL = 'normal';

export type MatchType =
  | typeof NOTIFICATION_MATCH_TYPE_SUPERBOOST
  | typeof NOTIFICATION_MATCH_TYPE_BOOST
  | typeof NOTIFICATION_MATCH_TYPE_SUPER_LIKE
  | typeof NOTIFICATION_MATCH_TYPE_FAST_MATCH
  | typeof NOTIFICATION_MATCH_TYPE_NORMAL;

export const NOTIFICATION_MESSAGE_TYPE_GIF = 'gif';
export const NOTIFICATION_MESSAGE_TYPE_SONG = 'song';
export const NOTIFICATION_MESSAGE_TYPE_CONTACT_CARD = 'contact_card';
export const NOTIFICATION_MESSAGE_TYPE_STICKER = 'sticker';

export type FormatMessagePayload = {
  id: string;
};

export type NotificationPayload = Record<
  string,
  {
    title?: string | [FormatMessagePayload];
    body?: string | [FormatMessagePayload, Record<string, any>?];
    theme?: NotificationTheme;
    avatarType?: MatchType;
  }
>;

export const NEW_MESSAGE_INTL_MAP: NotificationPayload = {
  [NOTIFICATION_MESSAGE_TYPE_GIF]: {
    title: [{ id: 'Notification.newMessageTitle' }],
    body: [{ id: 'UserSentYouAGif' }],
  },
  [NOTIFICATION_MESSAGE_TYPE_SONG]: {
    body: [{ id: 'UserSentYouASong' }],
  },
  [NOTIFICATION_MESSAGE_TYPE_CONTACT_CARD]: {
    title: [{ id: 'Notification.newMessageTitle' }],
    body: [{ id: 'UserSentYouAContactCard' }],
  },
  [NOTIFICATION_MESSAGE_TYPE_STICKER]: {
    title: [{ id: 'Notification.newMessageTitle' }],
    body: [{ id: 'UserSentYouASticker' }],
  },
};

export const NEW_MATCH_INTL_MAP: NotificationPayload = {
  [NOTIFICATION_MATCH_TYPE_SUPERBOOST]: {
    title: [{ id: 'Notification.newSuperBoostMatch' }],
  },
  [NOTIFICATION_MATCH_TYPE_BOOST]: {
    theme: NOTIFICATION_THEME_PURPLE,
    title: [{ id: 'Notification.newBoostMatch' }],
    avatarType: 'boost',
  },
  [NOTIFICATION_MATCH_TYPE_SUPER_LIKE]: {
    theme: NOTIFICATION_THEME_BLUE,
  },
  [NOTIFICATION_MATCH_TYPE_FAST_MATCH]: {
    title: [{ id: 'Notification.newMatchTitle' }],
  },
};

export const GET_UPDATES_DATA = 'GET_UPDATES_DATA';
export const POLL_UPDATES_DATA = 'POLL_UPDATES_DATA';

export const FETCH_INITIAL_MATCHES = 'FETCH_INITIAL_MATCHES';
export const FETCH_INITIAL_MATCHES_SUCCESS = 'FETCH_INITIAL_MATCHES_SUCCESS';
export const FETCH_MATCH = 'FETCH_MATCH';
export const FETCH_MATCH_FAILURE = 'FETCH_MATCH_FAILURE';
export const FETCH_MATCH_MESSAGES = 'FETCH_MATCH_MESSAGES';
export const FETCH_MATCH_MESSAGES_SUCCESS = 'FETCH_MATCH_MESSAGES_SUCCESS';
export const FETCH_MATCH_SUCCESS = 'FETCH_MATCH_SUCCESS';
export const FETCH_MATCHES = 'FETCH_MATCHES';
export const FETCH_MATCHES_SUCCESS = 'FETCH_MATCHES_SUCCESS';
export const FETCH_UPDATES = 'FETCH_UPDATES';
export const FETCH_UPDATES_SUCCESS = 'FETCH_UPDATES_SUCCESS';

export const START_UPDATES_ROOT_SAGA = 'START_UPDATES_ROOT_SAGA';
export const CANCEL_UPDATES_ROOT_SAGA = 'CANCEL_UPDATES_ROOT_SAGA';
export const SHOW_NEW_MATCH_AND_MESSAGE_NOTIFICATIONS = 'SHOW_NEW_MATCH_AND_MESSAGE_NOTIFICATIONS';
